import Cookies from 'js-cookie';
import { FC, createContext, useState, useEffect, ReactNode } from 'react';

interface ForSaleBrokerContextTypes {
  isAuthorizedBroker?: boolean;
  showErrorForSale?: boolean;
  setShowErrorForSale(val: boolean): void;
  setIsAuthorizedBroker(val: boolean): void;
}

type Props = {
  children: ReactNode;
};

export const ForSaleBrokerContext = createContext<ForSaleBrokerContextTypes>(
  {} as ForSaleBrokerContextTypes
);

const ForSaleBrokerContextProvider: FC<Props> = ({ children }) => {
  const [isAuthorizedBroker, setIsAuthorizedBroker] = useState<boolean>(false);
  const [showErrorForSale, setShowErrorForSale] = useState<boolean>(false);

  useEffect(() => {
    var loginType = Cookies.get('loginType');
    setIsAuthorizedBroker(loginType === '2');
  }, []);

  const contextObject: ForSaleBrokerContextTypes = {
    isAuthorizedBroker,
    showErrorForSale,
    setShowErrorForSale,
    setIsAuthorizedBroker,
  };

  return (
    <ForSaleBrokerContext.Provider value={contextObject}>
      {children}
    </ForSaleBrokerContext.Provider>
  );
};

export default ForSaleBrokerContextProvider;
